import React from "react"
import { Navigate } from "react-router-dom"
import { connect } from "react-redux"

const mapStateToProps = (storeState, ownProps) => {
  const { sessionId } = storeState.session
  return {
    ...ownProps,
    loggedIn: sessionId != null
  }
};

const LoginPageRoute = ({ loggedIn, children }) => {
  if (loggedIn) {
    return <Navigate to="/" />;
  }
  return children;
}

export default connect(mapStateToProps)(LoginPageRoute);